// extracted by mini-css-extract-plugin
export var cardIcon = "_18-5";
export var cardIconUnframed = "_18-9";
export var checkboxCard = "_18-0";
export var checkboxCardSelected = "_18-4";
export var disabled = "_18-2";
export var interactive = "_18-1";
export var outerBorder = "_18-3";
export var spacerMedium = "_18-8";
export var spacerSmall = "_18-7";
export var spacerXsmall = "_18-6";